import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

interface IGuide {
    benefit?: string
    guide_link?: string
    register_link?: string
}

interface IExchange {
    display_name?: string
    featured?: boolean
    guide?: IGuide
    guide_screenshot?: any
    guideline?: string
    icon?: string
    ip?: string
    is_copybot_allowed?: boolean
    logo?: string
    name?: string
    oauth_link?: string
    oauth_login_link?: string
    pass_phrase?: boolean
    price?: boolean
    rank?: number
    ref_url?: string
    signal?: number
}

export const getExchanges = async (): Promise<ApiRes<IExchange[]>> => {
    return await apiGet(API_URL, `exchanges`)
}
